module.exports = __webpack_public_path__ + "static/media/light-theme-duration.8211c43e.svg";